"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.screen = void 0;
// Screen sizes
exports.screen = {
    xs: 500,
    sm: 768,
    md: 1024,
    lg: 1600,
    get xsMax() {
        return this.xs;
    },
    get xsMin() {
        return this.xs + 1;
    },
    get smMax() {
        return this.sm;
    },
    get smMin() {
        return this.sm + 1;
    },
    get mdMax() {
        return this.md;
    },
    get mdMin() {
        return this.md + 1;
    },
    get lgMax() {
        return this.lg;
    },
    get lgMin() {
        return this.lg + 1;
    },
};
//# sourceMappingURL=screen.js.map